export * from './index';



//////////////////
// WEBPACK FOOTER
// ./node_modules/ng2-translate/ng2-translate.js
// module id = 868
// module chunks = 3